export default {
  "NoticeConfigContents.Title1": "電話・郵送によるご案内",
  "NoticeConfigContents.Title2": "主な電子メール・SMSによるご案内",
  "NoticeConfigContents.SubTitle1": "日本国内／国外のお客さま共通",
  "NoticeConfigContents.SubTitle2": "日本国内のお客様向け",
  "NoticeConfigContents.LinkCardTitle1": "キャンペーン・特典などのお知らせ",
  "NoticeConfigContents.LinkCardTitle4": "Myインフォメール",
  "NoticeConfigContents.BackButtonText": "トップページへ戻る",
}
